/* Public Shopify collection data only. No network writes or checkout authority. */
(() => {
  'use strict';
  const products = new Map();
  const safeImage = value => {
    if (!value) return null;
    try {
      const url = new URL(value, location.origin);
      return url.protocol === 'https:' && (url.origin === location.origin || url.hostname === 'cdn.shopify.com') ? url.href : null;
    } catch (_) { return null; }
  };
  try {
    const payload = JSON.parse(document.querySelector('[data-native-catalog]')?.textContent || '{}');
    for (const entry of (Array.isArray(payload.products) ? payload.products : []).slice(0, 50)) {
      if (!entry || !/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(entry.handle) || typeof entry.title !== 'string'
          || !['PHP', 'USD'].includes(entry.price_currency) || !Number.isFinite(entry.price_amount) || entry.price_amount <= 0
          || typeof entry.available !== 'boolean' || typeof entry.url !== 'string'
          || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9-]+(?:\?[^\s]*)?$/i.test(entry.url)) continue;
      const url = new URL(entry.url, location.origin);
      if (url.origin !== location.origin || /[\u0000-\u0020\\]/.test(entry.url)) continue;
      products.set(entry.handle, {...entry, image: safeImage(entry.image)});
    }
  } catch (_) { /* A malformed optional payload leaves the concept view intact. */ }
  const crystalBracelets = {"green-continuum-bracelet": {"category": "bracelets", "subtype": "bracelets", "type": "Crystal bracelet", "color": "violet", "name": "Purple Continuum Bracelet"}, "lime-geometry-studs": {"category": "bracelets", "subtype": "bracelets", "type": "Crystal bracelet", "color": "violet", "name": "Cloud Quartz Bracelet"}, "rose-and-green-pendant": {"category": "bracelets", "subtype": "bracelets", "type": "Crystal bracelet", "color": "violet", "name": "Mist Quartz Bracelet"}, "verdant-angle-brooch": {"category": "bracelets", "subtype": "bracelets", "type": "Crystal bracelet", "color": "violet", "name": "Dawn Quartz Bracelet"}};
  const apply = item => {
    const route = item.route || item.url || '';
    const handle = item.handle || route.split('/').pop()?.replace(/^piece-/, '').split('?')[0].split('#')[0];
    const product = products.get(handle);
    if (!product) return item;
    return {...item, ...(crystalBracelets[handle] || {}), native_product:true, handle, name:product.title, title:product.title,
      route:product.url, url:product.url, price_amount:product.price_amount,
      price_currency:product.price_currency, price_type:'selling', price_varies:product.price_varies === true,
      available:product.available, image:product.image || item.image,
      image_alt:product.title, alt:product.title};
  };
  const formatPrice = item => `${item.price_varies ? 'From ' : ''}${item.price_currency} ${item.price_amount.toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})}`;
  window.EasternNativeCatalog = Object.freeze({apply, formatPrice});
})();
